import React from "react";
import { motion } from "framer-motion";
import "./tests-we-offer.css";

const TestsWeOffer = () => {
  const tests = [
    "Hereditary Breast and Ovarian Cancer",
    "Hereditary Colon Cancer",
    "Hereditary Pancreatic Cancer",
    "Hereditary Prostate Cancer",
    "Comprehensive Hereditary Cancer",
    "Solid Cancer Panel",
    "Myeloid Cancer Panel",
    "Non-Invasive Prenatal Screening (NIPS)",
  ];

  const titleVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 120,
        duration: 0.5,
      },
    },
  };

  return (
    <section id="our-offered-tests" className="tests-we-offer-section">
      <motion.h2
        className="tests-offered-title"
        variants={titleVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        Tests we offer
      </motion.h2>

      <div className="scroller-container">
        {/* First scroller, moving backward (right to left) */}
        <div className="scroller" data-direction="backward">
          <div className="scroller-inner">
            {[...tests, ...tests].map((test, index) => (
              <div key={`backward-${index}`} className="test-item-scroller">
                {test}
              </div>
            ))}
          </div>
        </div>

        {/* Second scroller, moving forward (left to right) */}
        <div className="scroller" data-direction="forward">
          <div className="scroller-inner">
            {[...tests, ...tests].map((test, index) => (
              <div key={`forward-${index}`} className="test-item-scroller">
                {test}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestsWeOffer;